

















































import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class ModalBox extends Vue {
  @Prop()
  private pmModalTitle!: string;
  private maskClosable: boolean = false;
  private inputDisabled: boolean = true;
  private visible: boolean = false;
  private modelWidth: number = 900;
  private destroyOnCloseModal: boolean = true;
  private modalDisabled: boolean = true;
  private last: number = 0;
  private dataJson: any = [];
  @Prop({
    default: () => {
      return {};
    },
  })
  private argsJson: any;
  private async editorShowModal(boo: boolean, productNumber: string) {
    this.getData();
    const that = this;
    this.visible = true;
    // 根据产品编码  找产品  填充信息
    const data = await this.getPMProductData(productNumber);
    this.setData(data);
  }
  private setData(data: any) {
    this.$set(this.argsJson, 'pmName', data[0].pmName);
    this.$set(this.argsJson, 'productName', data[0].productName);
    this.$set(this.argsJson, 'pmNameAbb', data[0].productNumber);
    this.$set(this.argsJson, 'brand', data[0].brand);
    this.$set(this.argsJson, 'asin', data[0].asin);
    this.$set(this.argsJson, 'store', data[0].store);
  }
  private async deleteShowModal(boo: boolean, productNumber: string) {
    this.getData();
    const that = this;
    this.visible = true;
    const data = await this.getPMProductData(productNumber);
    this.setData(data);
  }
  private getPMProductData(productNumber: string) {
    const that = this;
    return new Promise((resolve: any, reject: any) => {
      const url = '/api/getPMProductData';
      const args = {
        productNumber,
      };
      this.axios.post(url, args).then((res) => {
        if (res.data.data.length > 0) {
          that.modalDisabled = false;
          resolve(res.data.data);
        } else {
          that.$message.error('产品编号错误');
          that.visible = false;
          reject();
        }
      });
    });
  }
  private showModal(boo: boolean, titleStatus: string) {
    this.visible = true;
    if ( titleStatus === '创建' ) {
      this.getData();
    } else if ( titleStatus === '修改' ) {
      console.log(2);
    } else if ( titleStatus === '删除' ) {
      console.log(2);
    }
  }
  private changeProductName(event: any) {
    const that = this;
    that.last = event.timeStamp;
    setTimeout(() => {
      if (that.last - event.timeStamp === 0) {
        // 你的逻辑
        const url = '/api/getPMProductName';
        const args = {
          productName: that.argsJson.productName,
        };
        that.axios.post(url, args).then((res) => {
          if (res.data.data.length > 0) {
            that.modalDisabled = true;
            that.$message.error('产品名称重复,请修改');
          } else {
            that.modalDisabled = false;
          }
        });
      }
    }, 900);
  }
  private getData() {
    const that = this;
    const url = '/api/getSelectPMTracking';
    const args = {};
    this.axios.post(url, args).then((res) => {
      that.dataJson = res.data.data;
    });
  }
  private emitEmpty(box: any, oKey: string, value: any): void {
    const inputBox: HTMLInputElement = this.$refs[box] as HTMLInputElement;
    inputBox.focus();
    // this.$set(this.modalJson, oKey, value);
  }
  private onChangeDate(date: any, dateString: string) {
    // console.log(date, dateString);
  }
  private handleOk(e: any) {
    const that = this;
    if ( this.pmModalTitle === '创建' ) {
      const url = '/api/getTrackinSavePMInfo';
      const args = this.argsJson;
      this.axios.post(url, args).then((res) => {
        that.cleanArgsJson();
        that.visible = false;
        that.$emit('getDataRefresh');
      });
    } else if ( this.pmModalTitle === '修改' ) {
      const url = '/api/getTrackingEditor';
      const args = this.argsJson;
      this.axios.post(url, args).then((res) => {
        that.cleanArgsJson();
        that.visible = false;
        that.$emit('getDataRefresh');
      });
    } else if ( this.pmModalTitle === '删除' ) {
      const url = '/api/getTrackingDelete';
      const args = this.argsJson;
      this.axios.post(url, args).then((res) => {
        that.cleanArgsJson();
        that.visible = false;
        that.$emit('getDataRefresh');
      });
    }
  }
  private handleCancel(e: any) {
    this.visible = false;
    this.cleanArgsJson();
  }
  private cleanArgsJson() {
    const that = this;
    // that.$set(that.argsJson, {});
    Object.keys(that.argsJson).forEach((key: any) => (that.argsJson[key] = ''));
  }
  private handleChange(value: string, type: string) {
    const that = this;
    if (type === 'pmName' && this.pmModalTitle === '创建') {
      const data = this.dataJson[0];
      const url = '/api/getTrackingPMLength';
      const args = {
        pmName: value,
      };
      const pmNameAbbStr = 'pmNameAbb';
      const pmNameStr = 'pmName';
      this.axios.post(url, args).then((res) => {
        data.forEach((list: any) => {
          if (list[pmNameStr] === value) {
            const pmNameAbb =  'SZKB' + list[pmNameAbbStr] + res.data.data;
            that.$set(that.argsJson, 'pmNameAbb', pmNameAbb);
          }
        });
      });

    }
  }
}
